import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Onlinecabbookingnavimumbaiairport() {



  const cardData = {
    keyword: " Online Cab Booking Navi Mumbai Airport   ",


"headingDescription": "Royal Route Cab offers easy and reliable online cab booking for Navi Mumbai Airport, providing safe, comfortable, and affordable airport transfers for arrivals, departures, and intercity travel. Our online booking system allows passengers to quickly reserve a cab in advance or on-demand with instant confirmation, transparent pricing, and 24/7 customer support. Whether you are traveling for business, family trips, or solo journeys, we ensure punctual pickups, real-time flight tracking, and hassle-free doorstep service across Navi Mumbai, Mumbai, and nearby regions. Our fleet includes air-conditioned sedans, SUVs, Innova, Ertiga, Kia Carens, Innova Crysta, and Tempo Travellers suitable for all travel needs. With professional drivers and clean vehicles, Royal Route Cab is a trusted choice for online cab booking at Navi Mumbai Airport.",

"topPlaces": [
  {
    "title": "Instant Online Booking System",
    "description": "Our instant online booking system for Navi Mumbai Airport allows passengers to book a cab within seconds using mobile or desktop. Users can select pickup location, drop destination, vehicle type, and travel time easily. The system provides instant confirmation, fare estimates, and driver details, ensuring a smooth and transparent booking experience without delays or confusion."
  },
  {
    "title": "Airport Pickup Service",
    "description": "The airport pickup service ensures that passengers arriving at Navi Mumbai Airport are greeted by professional drivers at the designated pickup zone. With real-time flight tracking, drivers adjust pickup timing based on delays or early arrivals. Luggage assistance and comfortable vehicles make post-flight travel easy and stress-free, especially for families and business travelers."
  },
  {
    "title": "Airport Drop Service",
    "description": "Airport drop service provides timely and reliable transportation from any location in Navi Mumbai or nearby cities directly to the airport. Drivers plan routes based on traffic conditions to ensure passengers reach well before departure time. This service is ideal for early morning flights, late-night departures, and corporate travel schedules."
  },
  {
    "title": "Intercity Travel from Airport",
    "description": "Passengers can book direct intercity rides from Navi Mumbai Airport to destinations like Pune, Nashik, Shirdi, Lonavala, Surat, and Mumbai. This eliminates the need for multiple bookings and ensures seamless long-distance travel with comfortable vehicles, experienced drivers, and door-to-door service across Maharashtra and Gujarat routes."
  },
  {
    "title": "Corporate Online Cab Booking",
    "description": "Corporate travelers benefit from dedicated online cab booking services for airport transfers, meetings, and business travel. Companies can schedule rides in advance for employees or clients with reliable timing, professional chauffeurs, and clean executive-class vehicles for a premium experience."
  },
  {
    "title": "Family & Group Cab Booking",
    "description": "Families and groups can easily book larger vehicles like Innova, Ertiga, Kia Carens, and Tempo Travellers for airport travel. These vehicles provide spacious seating, extra luggage capacity, and comfortable interiors, making group airport transfers convenient and organized without the need for multiple cars."
  },
  {
    "title": "24/7 Availability",
    "description": "Online cab booking for Navi Mumbai Airport is available 24/7, ensuring passengers can book rides anytime, regardless of flight schedules. Whether it is early morning departure or late-night arrival, reliable cab service is always available for smooth transportation."
  },
  {
    "title": "Safe & Verified Drivers",
    "description": "All drivers are verified, experienced, and trained to ensure passenger safety and comfort. They follow traffic regulations, assist with luggage, and provide polite and professional service throughout the journey, making airport travel secure and reliable."
  },
  {
    "title": "Transparent Pricing",
    "description": "Online booking ensures clear and upfront pricing with no hidden charges. Passengers receive fare estimates before booking, allowing them to choose suitable vehicle options based on budget and travel needs without any last-minute surprises."
  },
  {
    "title": "Multiple Payment Options",
    "description": "Customers can pay easily using online payment methods such as UPI, cards, wallets, or cash. This flexibility makes booking convenient for all types of passengers, ensuring a smooth and hassle-free transaction process."
  }
],






services: [
  {
    name: "Online Cab Booking Navi Mumbai Airport",
    description: "Online cab booking Navi Mumbai airport offers a quick and convenient way to reserve your airport ride. Customers can select vehicle type, pickup time, and location easily. Instant confirmation and secure payment enhance convenience. It ensures hassle-free airport travel."
  },
  {
    name: "Navi Mumbai Airport Online Cab Booking",
    description: "Navi Mumbai airport online cab booking provides seamless booking for airport pickups and drops. This service allows travelers to pre-book rides with flexible scheduling. Clean vehicles and professional drivers ensure comfort. It guarantees a smooth experience."
  },
  {
    name: "Book Cab Online Navi Mumbai Airport",
    description: "Book cab online Navi Mumbai airport with easy steps and instant confirmation. Customers can choose from sedan, SUV, and premium vehicles. Transparent pricing ensures no hidden charges. It simplifies travel planning."
  },
  {
    name: "Navi Mumbai Airport Cab Booking Online",
    description: "Navi Mumbai airport cab booking online ensures fast and reliable reservations for airport travel. Travelers can select preferred vehicle and timing. Secure payment options enhance convenience. It ensures a stress-free booking process."
  },
  {
    name: "Online Taxi Booking Navi Mumbai Airport",
    description: "Online taxi booking Navi Mumbai airport provides convenient and quick booking for airport transfers. This service ensures availability of vehicles anytime. Comfortable seating enhances travel experience. It guarantees reliable transport."
  },
  {
    name: "Best Online Cab Booking Navi Mumbai Airport",
    description: "Best online cab booking Navi Mumbai airport ensures top-quality vehicles, professional drivers, and excellent customer support. This service focuses on comfort and punctuality. It guarantees a premium airport travel experience."
  },
  {
    name: "Cheap Online Cab Booking Navi Mumbai Airport",
    description: "Cheap online cab booking Navi Mumbai airport offers budget-friendly travel options without compromising safety. Transparent pricing ensures no hidden charges. Ideal for cost-conscious travelers. It ensures economical airport transfers."
  },
  {
    name: "Reliable Online Cab Booking Navi Mumbai Airport",
    description: "Reliable online cab booking Navi Mumbai airport provides dependable transportation with verified drivers and well-maintained vehicles. This service ensures timely pickups and drops. It guarantees a safe and comfortable journey."
  },
  {
    name: "Instant Cab Booking Navi Mumbai Airport",
    description: "Instant cab booking Navi Mumbai airport allows travelers to book rides quickly for urgent travel needs. Fast confirmation and quick availability ensure convenience. Ideal for last-minute bookings. It guarantees immediate service."
  },
  {
    name: "Advance Cab Booking Navi Mumbai Airport",
    description: "Advance cab booking Navi Mumbai airport helps travelers schedule rides in advance for planned trips. This service ensures availability during peak hours. Flexible booking options enhance convenience. It guarantees timely service."
  },
  {
    name: "24x7 Online Cab Booking Navi Mumbai Airport",
    description: "24x7 online cab booking Navi Mumbai airport provides round-the-clock booking options for all travel needs. This service is ideal for late-night and early-morning flights. Quick booking ensures convenience. It guarantees service anytime."
  }
],

tableData: [
  ["Online Cab Booking Navi Mumbai Airport", "Navi Mumbai Airport Online Cab Booking"],
  ["Book Cab Online Navi Mumbai Airport", "Navi Mumbai Airport Cab Booking Online"],
  ["Online Taxi Booking Navi Mumbai Airport", "Best Online Cab Booking Navi Mumbai Airport"],
  ["Cheap Online Cab Booking Navi Mumbai Airport", "Reliable Online Cab Booking Navi Mumbai Airport"],
  ["Instant Cab Booking Navi Mumbai Airport", "Advance Cab Booking Navi Mumbai Airport"],
  ["24x7 Online Cab Booking Navi Mumbai Airport", ""]
],


whychoose: [
  {
    WhyChooseheading: "Easy Online Cab Booking for Navi Mumbai Airport",
    WhyChoosedescription: "Royal Route Cabs offers quick and hassle-free online cab booking for Navi Mumbai Airport with instant confirmation and smooth service."
  },
  {
    WhyChooseheading: "Instant Booking & Quick Confirmation",
    WhyChoosedescription: "Book your airport cab online in just a few clicks and receive instant confirmation for a stress-free travel experience."
  },
  {
    WhyChooseheading: "24/7 Online Cab Availability",
    WhyChoosedescription: "Our online cab booking service for Navi Mumbai Airport is available round the clock for all travel needs."
  },
  {
    WhyChooseheading: "On-Time Pickup with Flight Tracking",
    WhyChoosedescription: "We monitor flight timings to ensure timely pickup even during delays, making airport transfers seamless."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear pricing including tolls and parking charges with no hidden costs."
  },
  {
    WhyChooseheading: "Professional & Verified Drivers",
    WhyChoosedescription: "Our drivers are trained, verified, and experienced in airport routes, ensuring safe and reliable travel."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for group travel."
  },
  {
    WhyChooseheading: "Trusted Airport Booking Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by customers for reliable online cab booking to Navi Mumbai Airport with punctual service."
  }
]

};

const faqData = [
  { question: "Can I book cab online for Navi Mumbai Airport?", answer: "Yes, Royal Route Cabs offers easy online cab booking for Navi Mumbai Airport with instant confirmation." },
  { question: "Is online cab booking available 24 hours?", answer: "Yes, our online booking service operates 24/7." },
  { question: "How can I book airport cab online?", answer: "You can book through our website or contact us via phone for quick booking." },
  { question: "Do you provide instant booking confirmation?", answer: "Yes, you receive instant confirmation after booking." },
  { question: "Do you track flight delays?", answer: "Yes, we monitor flight timings for timely pickup." },
  { question: "Which vehicles are available?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Can I book one-way airport cab online?", answer: "Yes, one-way and round-trip options are available." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for guaranteed availability." },
  { question: "Do you provide pickup from all locations?", answer: "Yes, we provide pickup from Mumbai, Navi Mumbai, Thane, and nearby areas." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Karan Deshmukh",
    feedback: "Booking a Navi Mumbai Airport cab online with Royal Route Cabs was very quick and convenient. The cab arrived on time and the ride was smooth and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Patil",
    feedback: "Very easy online booking for Navi Mumbai Airport cab. The service was punctual, the vehicle was clean, and the overall experience felt reliable and hassle-free.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Online Cab Booking Navi Mumbai Airport",
  "image": "https://www.royalroutecabs.com/assets/images/online-cab-booking-navi-mumbai-airport.jpg", // replace if needed
  "description": "Book online cab for Navi Mumbai Airport with Royal Route Cabs for instant, reliable, and 24x7 airport pickup and drop services. Choose from sedan, SUV, Innova, Ertiga, and premium vehicles for comfortable travel.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "999", // starting airport booking fare (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/online-cab-booking-navi-mumbai-airport"
  }
};






  return (
    <div>
<Helmet>
  <title>Online Cab Booking Navi Mumbai Airport | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book online cab for Navi Mumbai Airport with Royal Route Cabs. Instant, affordable and 24x7 reliable airport taxi booking with professional drivers and comfortable cars."
  />

  <meta
    name="keywords"
    content="online cab booking navi mumbai airport, navi mumbai airport online cab booking, book cab online navi mumbai airport, navi mumbai airport cab booking online, online taxi booking navi mumbai airport, best online cab booking navi mumbai airport, cheap online cab booking navi mumbai airport, reliable online cab booking navi mumbai airport, instant cab booking navi mumbai airport, advance cab booking navi mumbai airport, 24x7 online cab booking navi mumbai airport"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/76.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onlinecabbookingnavimumbaiairport;